export const authMessage: Record<string, string> = {
    "auth/user-not-found": "Credenciais incorretas.",
    "auth/wrong-password": "Credenciais incorretas.",
};
